import { FieldSelect } from '@/components/looker/field-select';
import { useMe } from '@/hooks/use-me';
import { siteId } from '@/utils/format/customer';
import { singular } from '@/utils/format/label';
import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import { ListSites } from '../../queries/get-list-sites';

export type SiteFilterProps = {
  filters: IWarrantyRepository.Filters;
  onChange: (value?: string) => void;
};
export function SiteFilter({ filters, onChange }: SiteFilterProps) {
  const me = useMe();
  const listSites = ListSites.useQuery();

  return (
    <FieldSelect
      label={singular(me.config.group.labels.name)}
      placeholder={`Filter by ${singular(me.config.group.labels.name)}`}
      value={filters.siteId}
      options={
        listSites.data?.sites.map(({ fullFrontendId }) => ({
          value: fullFrontendId,
        })) ?? []
      }
      onChange={(label) => onChange(siteId(label) ?? undefined)}
      isClearable={false} // Prevent clearing the selection
      required // Indicates the field is required
    />
  );
}
